import axios from 'axios';
import { basicAuthConfig } from '../configs';
import { urlMyspreadApi } from '../urls';

/**
 * API para gestión de Empresas
 * Maneja la comunicación con el backend para obtener y modificar empresas
 */

/**
 * Obtener todas las empresas
 * @param {Object} user - Usuario autenticado
 * @returns {Promise} Response con estructura completa de empresas
 */
const getEmpresas = async (user, params = '') => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/empresas/';
    if (params && typeof params === 'string') {
      endpoint += params.startsWith('?') ? params : `?${params}`;
    }
    const response = await axios.get(endpoint, config);
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
        total: response.data.total
      };
    }
    return {
      success: false,
      error: 'No se recibieron datos del servidor',
      data: []
    };
  } catch (error) {
    console.error('Error al obtener empresas:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener empresas',
      data: []
    };
  }
};

/**
 * Obtener empresa específica
 * @param {Object} user - Usuario autenticado
 * @param {number} idEmpresa - ID de la empresa
 * @returns {Promise} Response con datos de la empresa
 */
const getEmpresaById = async (user, idEmpresa) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/empresas/${idEmpresa}`;
    const response = await axios.get(endpoint, config);
    if (response.data) {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    }
    return {
      success: false,
      error: 'No se recibieron datos del servidor'
    };
  } catch (error) {
    console.error('Error al obtener empresa:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al obtener empresa'
    };
  }
};

/**
 * Crear empresa
 * @param {Object} user - Usuario autenticado
 * @param {Object} empresaData - Datos de la empresa a crear
 * @returns {Promise} Response con resultado de la operación
 */
const createEmpresa = async (user, empresaData) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/empresas/`;
    const response = await axios.post(endpoint, empresaData, config);
    return {
      success: true,
      data: response.data,
      message: 'Empresa creada exitosamente'
    };
  } catch (error) {
    console.error('Error al crear empresa:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al crear empresa',
      details: error.response?.data
    };
  }
};

/**
 * Actualizar empresa (no se usará por ahora)
 * @param {Object} user - Usuario autenticado
 * @param {number} idEmpresa - ID de la empresa
 * @param {Object} empresaData - Nuevos datos de la empresa
 * @returns {Promise} Response con resultado de la operación
 */
const updateEmpresa = async (user, idEmpresa, empresaData) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/empresas/${idEmpresa}`;
    const response = await axios.put(endpoint, empresaData, config);
    return {
      success: true,
      data: response.data,
      message: 'Empresa actualizada exitosamente'
    };
  } catch (error) {
    console.error('Error al actualizar empresa:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al actualizar empresa',
      details: error.response?.data
    };
  }
};

/**
 * Eliminar empresa (no se usará por ahora)
 * @param {Object} user - Usuario autenticado
 * @param {number} idEmpresa - ID de la empresa
 * @returns {Promise} Response con resultado de la operación
 */
const deleteEmpresa = async (user, idEmpresa) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/empresas/${idEmpresa}`;
    await axios.delete(endpoint, config);
    return {
      success: true,
      message: 'Empresa eliminada exitosamente'
    };
  } catch (error) {
    console.error('Error al eliminar empresa:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Error al eliminar empresa',
      details: error.response?.data
    };
  }
};

export {
  getEmpresas,
  getEmpresaById,
  createEmpresa,
  updateEmpresa,
  deleteEmpresa
};
